import { createContext, useEffect, useState } from "react";
import { isEmpty } from "../../utils/utils";
import { getConfigLabel } from "../../services/configuration-service";

const ConfigurationContext = createContext();

export const ConfigurationContextProvider = ({ children }) => {
  const [formLabels, setFormLabels] = useState(null);

  useEffect(() => {
    if (isEmpty(formLabels))
      getConfigLabel().then((response) => {
        setFormLabels(response);
      });
  }, [formLabels]);

  return (
    <ConfigurationContext.Provider value={{ formLabels, setFormLabels }}>
      {children}
    </ConfigurationContext.Provider>
  );
};

export default ConfigurationContext;
